import React, {Component} from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  NavLink,
  Badge
} from 'reactstrap';
import { inject, observer } from "mobx-react";

@inject("userStore", "notifyStore") @observer
class Header extends Component {
  constructor() {
    super();
    this.state = {
      isLoggingOut: false,
    }
  }

  sidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  };

  sidebarMinimize = (e) => {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  };

  mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  };

  asideToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  };

  handleLogOut = async () => {
    this.setState({isLoggingOut: true});
    await this.props.userStore.logout();
    this.setState({isLoggingOut: false});
  };

  render() {
    const { userStore, notifyStore } = this.props;
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"> </span>
        </NavbarToggler>
        <NavbarBrand href="/#/dashboard"> </NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon"> </span>
        </NavbarToggler>
        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/#/users/list">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="/#/contractors/list-approved">Contractors</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="/#/projects/list-approved">Projects</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="/#/products/list-approved">Products</NavLink>
          </NavItem>
        </Nav>

        <Nav className="ml-auto" navbar>
          <NavItem className="d-md-down-none" onClick={() => this.handleLogOut()}>
            <NavLink href="#">Hello, <strong>{userStore.userData.name || "Guest"}</strong> {
              !!userStore.userData.name ? `(${this.state.isLoggingOut ? 'Logout...' : 'Logout'})` : ""
            }</NavLink>
          </NavItem>
          <NavItem>
            <NavbarToggler className="d-md-down-none" onClick={this.asideToggle}>
              <a className="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                <i className="icon-bell"> </i>
                <span className="badge badge-pill badge-danger" style={{fontSize: '.75rem'}}>
                  {notifyStore.listNotify.filter(item => item.read !== true).length}
                </span>
              </a>
            </NavbarToggler>
          </NavItem>
        </Nav>
        <div style={{padding: '0 8px'}}> </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js